import { ItemDataType } from "rsuite5/esm/@types/common";

/**
 * 审核状态type
 */
export enum APPROVED_TYPE {
  /**
   * 拒绝
   */
  'REFUSE' = -1,
  /**
   * 待审核
   */
  'PENDING' = 0,
  /**
   * 审核通过
   */
  'APPROVED' = 1,
  /**
   * 全部
   */
  'ALL' = 2,
  /**
   * 人工审核
   */
  'MANUAL' = 3,
}

/**
 * 审核状态
 */
export const ApproveStatus = {
  [APPROVED_TYPE.REFUSE]: '拒绝',
  [APPROVED_TYPE.PENDING]: '待审核',
  [APPROVED_TYPE.APPROVED]: '审核通过',
  [APPROVED_TYPE.ALL]: '全部',
  [APPROVED_TYPE.MANUAL]: '人工审核',
};

/**
 * 审核状态下拉框
 */
export const approveStatusData: ItemDataType[] = [
  {
    label: ApproveStatus[APPROVED_TYPE.ALL],
    value: APPROVED_TYPE.ALL,
  },
  {
    label: ApproveStatus[APPROVED_TYPE.APPROVED],
    value: APPROVED_TYPE.APPROVED,
  },
  {
    label: ApproveStatus[APPROVED_TYPE.PENDING],
    value: APPROVED_TYPE.PENDING,
  },
  {
    label: ApproveStatus[APPROVED_TYPE.REFUSE],
    value: APPROVED_TYPE.REFUSE,
  },
  {
    label: ApproveStatus[APPROVED_TYPE.MANUAL],
    value: APPROVED_TYPE.MANUAL,
  },
];

/**
 * 小票审核列表查询
 */
export interface ExamineListInfo {
  /**
   * 页数
   */
  page?: number;
  /**
   * 购物村
   */
  shopping_village?: number,
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 用户名
   */
  name?: string;
  /**
   * 会员等级
   */
  level?: number;
  /**
   * 品牌id
   */
  brand_id?: number[];
  /**
   * 消费时间(start_at、end_at)
   */
  time_range?: string[];
  /**
   * 消费时间开始时间
   */
  start_at?: string;
  /**
   * 消费时间结束时间
   */
  end_at?: string;
  /**
   * 上传时间(start_create_at、end_create_at)
   */
  create_time?: string[];
  /**
   * 上传开始时间
   */
  start_create_at?: string;
  /**
   * 上传结束时间
   */
  end_create_at?: string;
  /**
   * 审核状态
   */
  approved?: APPROVED_TYPE.ALL | APPROVED_TYPE.APPROVED | APPROVED_TYPE.PENDING | APPROVED_TYPE.REFUSE,
}

/**
 * 小票审核列表查询表单默认值
 */
export const defaultInfo: ExamineListInfo = {
  page: 1,
  shopping_village: null,
  phone: '',
  name: '',
  level: null,
  brand_id: [],
  time_range: [],
  start_at: '',
  end_at: '',
  create_time: [],
  start_create_at: '',
  end_create_at: '',
  approved: APPROVED_TYPE.PENDING,
};